import { createContext, ReactNode, useContext } from "react";

import { Route } from "@/core/types";
import { useVenueArchiveRoutesByClimbTypeQuery } from "@/hooks/routes";

type Query = ReturnType<
  typeof useVenueArchiveRoutesByClimbTypeQuery<{
    routes: Route[];
    count: number;
  }>
>;

const ArchiveRoutesQueryContext = createContext<Query | undefined>(undefined);

export const ArchiveQueryProvider = ({
  children,
  query,
}: {
  children: ReactNode;
  query: Query;
}) => {
  return (
    <ArchiveRoutesQueryContext.Provider value={query}>
      {children}
    </ArchiveRoutesQueryContext.Provider>
  );
};

export const useArchiveQueryContextRoutes = () => {
  const query = useContext(ArchiveRoutesQueryContext);
  if (!query) {
    throw new Error("useArchiveRoutes must be used within a ArchiveRoutesProvider");
  }
  return query.data?.routes;
};

export const useArchiveQueryContext = () => {
  const query = useContext(ArchiveRoutesQueryContext);
  if (!query) {
    throw new Error("useArchiveQuery must be used within a ArchiveRoutesProvider");
  }
  return query;
};
